<template>
  <div class="container mx-auto mt-12 space-y-8">
    <section class="content space-y-8">
      <h1 class="text-5xl font-extrabold">
        <a
          class="
            tomu-anchor
            bg-clip-text
            text-transparent
            bg-gradient-to-r
            from-green-400
            to-blue-500
          "
          id="contacts"
        >
          Контакты
        </a>
      </h1>

      <div class="tomu-contacts-grid">
        <div class="p-4">
          <p>ООО "Том Универсал"</p>
          <p>г. Томск, ул.В. Высоцкого, 25 ст. 3</p>

          <p>
            Тел.
            <a class="tomu-content-link" href="tel:+3822-515-300"
              >(3822) 515-300</a
            >
          </p>

          <p>
            Эл. почта:
            <a class="tomu-content-link" href="mailto:office@tomuniversal.ru"
              >office@tomuniversal.ru</a
            >
          </p>

          <p class="mt-4">Клеймо мастерской ФБУ Минтранса РФ1018</p>
          <p class="mt-4">
            Список мастерских Томского региона можно посмотреть
            <a
              class="tomu-content-link"
              href="http://rosavtotransport.ru/ru/activities/tachograph-control-ru/workshops/?action=district&id=70"
              target="_blank"
              >здесь
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 inline"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                /></svg
            ></a>
          </p>
        </div>

        <div title="Том Универсал Адрес Расположение Яндекс карты">
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3Adc3407d80d9d5c383547ee8abfdf8836c3c2b83d7db35c9d1fa493ccf96d4edf&amp;source=constructor"
            width="100%"
            height="400"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </section>

    <hr />

    <section class="content space-y-8">
      <h2 class="text-3xl">
        <a class="tomu-anchor" id="faq"></a>
        Часто задаваемые вопросы (FAQs)
      </h2>

      <p class="tomu-info">
        <vue-feather class="icon" type="alert-triangle"></vue-feather> Данный
        раздел находится в процессе разработки. Некоторые пункты меню, могут не
        содержать <strong>полной</strong> информации!
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "Contacts",
};
</script>

<style scoped>
.tomu-contacts-grid {
  @apply grid grid-cols-1;
  @apply border border-gray-200 divide-x divide-gray-200;
  @apply shadow-md;

  @screen 2xl {
    grid-template-columns: 1fr 2fr;
  }
}
</style>
